var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DonnesDansLesDeuxDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 33.484375 4.984375 A 1.50015 1.50015 0 0 0 32.439453 7.5605469 L 37.878906 13 L 6.5 13 A 1.50015 1.50015 0 1 0 6.5 16 L 37.878906 16 L 32.439453 21.439453 A 1.50015 1.50015 0 1 0 34.560547 23.560547 L 42.560547 15.560547 A 1.50015 1.50015 0 0 0 42.560547 13.439453 L 34.560547 5.4394531 A 1.50015 1.50015 0 0 0 33.484375 4.984375 z M 14.470703 23.986328 A 1.50015 1.50015 0 0 0 13.439453 24.439453 L 5.4394531 32.439453 A 1.50015 1.50015 0 0 0 5.4394531 34.560547 L 13.439453 42.560547 A 1.50015 1.50015 0 1 0 15.560547 40.439453 L 10.121094 35 L 41.5 35 A 1.50015 1.50015 0 1 0 41.5 32 L 10.121094 32 L 15.560547 26.560547 A 1.50015 1.50015 0 0 0 14.470703 23.986328 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DonnesDansLesDeuxDirections);
export default __webpack_public_path__ + "static/media/icons8-données-dans-les-deux-directions.ca7ce69b9b3205f6926e6f8c7627ee21.svg";
export { ForwardRef as ReactComponent };